import React, { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { ArrowLeft, Mail, Phone, MapPin, Euro, Building2, User, HandshakeIcon, MessageSquare, Calendar, Edit, Target, FileText, Download, X } from 'lucide-react';
const mockBrandData = {
  id: 1,
  name: 'Luxury Fashion Brand',
  category: 'Fashion',
  description: 'Brand di moda luxury con focus su abbigliamento e accessori di alta gamma. Presente sul mercato internazionale da oltre 20 anni.',
  website: 'www.luxuryfashionbrand.com',
  status: 'Attivo',
  createdDate: '15/03/2023',
  lastContact: '18/01/2024',
  budget: '800k-1M',
  preferredLocations: ['Montenapoleone', 'Via della Spiga', 'Corso Venezia'],
  interests: ['Retail', 'Boutique'],
  squareMeters: '100-150 m²',
  notes: 'Cliente molto interessato a location prestigiose nel quadrilatero della moda. Preferenza per immobili con vetrine ampie.'
};
const mockReferenti = [{
  id: 1,
  name: 'Marco Rossi',
  role: 'CEO',
  email: 'marco.rossi@luxurybrand.com',
  phone: '+39 02 1234567',
  isPrimary: true
}, {
  id: 2,
  name: 'Laura Bianchi',
  role: 'Real Estate Manager',
  email: 'laura.bianchi@luxurybrand.com',
  phone: '+39 02 1234568',
  isPrimary: false
}, {
  id: 3,
  name: 'Giuseppe Verdi',
  role: 'CFO',
  email: 'giuseppe.verdi@luxurybrand.com',
  phone: '+39 02 1234569',
  isPrimary: false
}];
const mockTrattative = [{
  id: 1,
  property: 'Via Montenapoleone 12',
  stage: 'Trattativa',
  value: 850000,
  startDate: '15/01/2024',
  lastUpdate: '18/01/2024'
}, {
  id: 2,
  property: 'Via della Spiga 8',
  stage: 'Proposta',
  value: 650000,
  startDate: '10/01/2024',
  lastUpdate: '16/01/2024'
}, {
  id: 3,
  property: 'Corso Venezia 45',
  stage: 'Chiusa',
  value: 720000,
  startDate: '05/12/2023',
  lastUpdate: '28/12/2023'
}];
const mockComunicazioni = [{
  id: 1,
  type: 'email',
  subject: 'Proposta Immobile Via Montenapoleone',
  date: '18/01/2024',
  from: 'Tu',
  to: 'Marco Rossi'
}, {
  id: 2,
  type: 'call',
  subject: 'Follow-up trattativa Via della Spiga',
  date: '16/01/2024',
  from: 'Laura Bianchi',
  to: 'Tu'
}, {
  id: 3,
  type: 'meeting',
  subject: 'Visita immobile Corso Venezia',
  date: '12/01/2024',
  from: 'Tu',
  to: 'Marco Rossi, Laura Bianchi'
}, {
  id: 4,
  type: 'email',
  subject: 'Invio documentazione contrattuale',
  date: '08/01/2024',
  from: 'Tu',
  to: 'Giuseppe Verdi'
}];
const mockEsigenze = [{
  id: 1,
  esigenza: 'Boutique in zona Montenapoleone',
  dettagli: '100-120 m², piano terra, vetrine ampie',
  budget: '800k-1M',
  dataRichiesta: '10/01/2024',
  soluzioneProposta: 'Via Montenapoleone 12',
  statoTrattativa: 'Trattativa'
}, {
  id: 2,
  esigenza: 'Retail Via della Spiga',
  dettagli: '80-100 m², possibilità mezzanino',
  budget: '600k-800k',
  dataRichiesta: '08/01/2024',
  soluzioneProposta: 'Via della Spiga 8',
  statoTrattativa: 'Proposta'
}, {
  id: 3,
  esigenza: 'Showroom zona Brera',
  dettagli: '150-200 m², spazi espositivi',
  budget: '700k-900k',
  dataRichiesta: '05/12/2023',
  soluzioneProposta: 'Corso Venezia 45',
  statoTrattativa: 'Chiusa'
}, {
  id: 4,
  esigenza: 'Boutique Corso Como',
  dettagli: '90-110 m², zona pedonale',
  budget: '650k-850k',
  dataRichiesta: '20/12/2023',
  soluzioneProposta: '-',
  statoTrattativa: 'In Ricerca'
}];
const mockImmobili = [{
  id: 1,
  nome: 'Via Montenapoleone 12',
  tipo: 'Retail',
  superficie: '120 m²',
  prezzo: 850000,
  immagine: 'https://uploadthingy.s3.us-west-1.amazonaws.com/4YkAY7UqKQUPpQ92yzEMgw/681b7f504e32f.jpg',
  descrizione: 'Prestigioso locale commerciale nel cuore del quadrilatero della moda milanese.',
  caratteristiche: ['Vetrine su strada', 'Aria condizionata', 'Sistema antifurto', 'Magazzino', 'Bagno', 'Certificazione energetica A'],
  galleria: ['https://uploadthingy.s3.us-west-1.amazonaws.com/4YkAY7UqKQUPpQ92yzEMgw/681b7f504e32f.jpg', 'https://uploadthingy.s3.us-west-1.amazonaws.com/nApHqCsLnhTw7aP1mFPzUT/Rodeo-Drive-Negozi.jpg', 'https://uploadthingy.s3.us-west-1.amazonaws.com/gggVNqt7oMzSPTA1GSg7hs/a0230d7093e3a80e46b36f3aff623d30.webp', 'https://uploadthingy.s3.us-west-1.amazonaws.com/oHDvCsUGQXrnWCVhpb6AR9/5-allestimento-punti-vendita-roma.jpg'],
  planimetria: 'https://images.unsplash.com/photo-1503387762-592deb58ef4e?w=800',
  mappa: 'https://uploadthingy.s3.us-west-1.amazonaws.com/daux6xG8NsQHUpRzjpKkfj/Screenshot_2025-11-05_alle_13.25.38.png'
}, {
  id: 2,
  nome: 'Via della Spiga 8',
  tipo: 'Boutique',
  superficie: '90 m²',
  prezzo: 650000,
  immagine: 'https://uploadthingy.s3.us-west-1.amazonaws.com/gggVNqt7oMzSPTA1GSg7hs/a0230d7093e3a80e46b36f3aff623d30.webp',
  descrizione: 'Boutique elegante in zona prestigiosa.',
  caratteristiche: ['Vetrine ampie', 'Aria condizionata', 'Bagno', 'Magazzino'],
  galleria: ['https://uploadthingy.s3.us-west-1.amazonaws.com/gggVNqt7oMzSPTA1GSg7hs/a0230d7093e3a80e46b36f3aff623d30.webp', 'https://uploadthingy.s3.us-west-1.amazonaws.com/4YkAY7UqKQUPpQ92yzEMgw/681b7f504e32f.jpg'],
  planimetria: 'https://images.unsplash.com/photo-1503387762-592deb58ef4e?w=800',
  mappa: 'https://uploadthingy.s3.us-west-1.amazonaws.com/daux6xG8NsQHUpRzjpKkfj/Screenshot_2025-11-05_alle_13.25.38.png'
}, {
  id: 3,
  nome: 'Corso Venezia 45',
  tipo: 'Showroom',
  superficie: '200 m²',
  prezzo: 720000,
  immagine: 'https://uploadthingy.s3.us-west-1.amazonaws.com/oHDvCsUGQXrnWCVhpb6AR9/5-allestimento-punti-vendita-roma.jpg',
  descrizione: 'Ampio showroom con spazi espositivi.',
  caratteristiche: ['Spazi espositivi', 'Aria condizionata', 'Bagno', 'Parcheggio'],
  galleria: ['https://uploadthingy.s3.us-west-1.amazonaws.com/oHDvCsUGQXrnWCVhpb6AR9/5-allestimento-punti-vendita-roma.jpg', 'https://uploadthingy.s3.us-west-1.amazonaws.com/nApHqCsLnhTw7aP1mFPzUT/Rodeo-Drive-Negozi.jpg'],
  planimetria: 'https://images.unsplash.com/photo-1503387762-592deb58ef4e?w=800',
  mappa: 'https://uploadthingy.s3.us-west-1.amazonaws.com/daux6xG8NsQHUpRzjpKkfj/Screenshot_2025-11-05_alle_13.25.38.png'
}];
const stageColors: Record<string, string> = {
  Trattativa: 'bg-blue-100 text-blue-800',
  Proposta: 'bg-yellow-100 text-yellow-800',
  Chiusa: 'bg-green-100 text-green-800',
  'In Ricerca': 'bg-gray-100 text-gray-800'
};
export function BrandDetail() {
  const {
    id
  } = useParams();
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState<'info' | 'immobili-interesse' | 'referenti' | 'trattative' | 'comunicazioni'>('info');
  const [selectedImmobile, setSelectedImmobile] = useState<(typeof mockImmobili)[0] | null>(null);
  const tabs = [{
    id: 'info' as const,
    label: 'Informazioni',
    icon: Building2
  }, {
    id: 'immobili-interesse' as const,
    label: 'Immobili di Interesse',
    icon: Target
  }, {
    id: 'referenti' as const,
    label: 'Referenti',
    icon: User
  }, {
    id: 'trattative' as const,
    label: 'Trattative',
    icon: HandshakeIcon
  }, {
    id: 'comunicazioni' as const,
    label: 'Storico Comunicazioni',
    icon: MessageSquare
  }];
  return <div className="space-y-6" data-id="element-273">
      <div className="flex items-center justify-between" data-id="element-274">
        <div className="flex items-center gap-4" data-id="element-275">
          <button onClick={() => navigate('/brands')} className="p-2 hover:bg-gray-100 rounded-lg transition-colors" data-id="element-276">
            <ArrowLeft className="w-5 h-5 text-gray-600" data-id="element-277" />
          </button>
          <div data-id="element-278">
            <h1 className="text-2xl font-semibold text-gray-900" data-id="element-279">
              {mockBrandData.name}
            </h1>
            <div className="flex items-center gap-4 mt-2" data-id="element-280">
              <span className="px-3 py-1 bg-gray-100 text-gray-700 text-sm rounded-full" data-id="element-281">
                {mockBrandData.category}
              </span>
              <span className={`px-3 py-1 text-sm rounded-full whitespace-nowrap ${mockBrandData.status === 'Attivo' ? 'bg-green-100 text-green-800' : 'bg-yellow-100 text-yellow-800'}`} data-id="element-282">
                {mockBrandData.status}
              </span>
            </div>
          </div>
        </div>
        <button className="flex items-center gap-2 px-4 py-2 bg-[#1388ad] text-white text-sm font-normal rounded-full hover:bg-[#0f6b8a] transition-colors" data-id="element-283">
          <Edit className="w-4 h-4" data-id="element-284" />
          Modifica
        </button>
      </div>
      <div className="bg-white border border-gray-200 rounded-lg overflow-hidden" data-id="element-285">
        <div className="border-b border-gray-200" data-id="element-286">
          <div className="flex overflow-x-auto" data-id="element-287">
            {tabs.map(tab => {
            const Icon = tab.icon;
            return <button key={tab.id} onClick={() => setActiveTab(tab.id)} className={`flex items-center gap-2 px-6 py-4 text-sm font-normal whitespace-nowrap transition-colors border-b-2 ${activeTab === tab.id ? 'border-[#1388ad] text-[#1388ad] bg-[#1388ad]/5' : 'border-transparent text-gray-600 hover:text-gray-900 hover:bg-gray-50'}`} data-id="element-288">
                  <Icon className="w-4 h-4" data-id="element-289" />
                  {tab.label}
                </button>;
          })}
          </div>
        </div>
        <div className="p-6" data-id="element-290">
          {activeTab === 'info' && <div className="space-y-6" data-id="element-291">
              <div data-id="element-292">
                <label className="text-sm font-semibold text-gray-700" data-id="element-293">
                  Descrizione
                </label>
                <p className="text-sm text-gray-600 mt-1" data-id="element-294">
                  {mockBrandData.description}
                </p>
              </div>
              <div data-id="element-295">
                <label className="text-sm font-semibold text-gray-700" data-id="element-296">
                  Sito Web
                </label>
                <a href={`https://${mockBrandData.website}`} target="_blank" rel="noopener noreferrer" className="text-sm text-[#1388ad] hover:underline mt-1 block" data-id="element-297">
                  {mockBrandData.website}
                </a>
              </div>
              <div data-id="element-298">
                <label className="text-sm font-semibold text-gray-700" data-id="element-299">
                  Note
                </label>
                <p className="text-sm text-gray-600 mt-1" data-id="element-300">
                  {mockBrandData.notes}
                </p>
              </div>
              <div data-id="element-301">
                <label className="text-sm font-semibold text-gray-700 mb-2 block" data-id="element-302">
                  Location Preferite
                </label>
                <div className="flex flex-wrap gap-2" data-id="element-303">
                  {mockBrandData.preferredLocations.map(location => <span key={location} className="px-3 py-1 bg-[#1388ad]/10 text-[#1388ad] text-sm rounded-full" data-id="element-304">
                      {location}
                    </span>)}
                </div>
              </div>
              <div data-id="element-305">
                <label className="text-sm font-semibold text-gray-700 mb-2 block" data-id="element-306">
                  Tipologie di Interesse
                </label>
                <div className="flex flex-wrap gap-2" data-id="element-307">
                  {mockBrandData.interests.map(interest => <span key={interest} className="px-3 py-1 bg-gray-100 text-gray-700 text-sm rounded-full" data-id="element-308">
                      {interest}
                    </span>)}
                </div>
              </div>
            </div>}
          {activeTab === 'immobili-interesse' && <div className="overflow-x-auto" data-id="element-309">
              <table className="w-full" data-id="element-310">
                <thead className="bg-gray-50 border-b border-gray-200" data-id="element-311">
                  <tr data-id="element-312">
                    <th className="px-4 py-3 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider" data-id="element-313">
                      Esigenza
                    </th>
                    <th className="px-4 py-3 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider" data-id="element-314">
                      Dettagli
                    </th>
                    <th className="px-4 py-3 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider" data-id="element-315">
                      Budget
                    </th>
                    <th className="px-4 py-3 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider" data-id="element-316">
                      Data Richiesta
                    </th>
                    <th className="px-4 py-3 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider" data-id="element-317">
                      Soluzione Proposta
                    </th>
                    <th className="px-4 py-3 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider" data-id="element-318">
                      Stato
                    </th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-200" data-id="element-319">
                  {mockEsigenze.map(esigenza => <tr key={esigenza.id} className="hover:bg-gray-50 transition-colors" data-id="element-320">
                      <td className="px-4 py-4" data-id="element-321">
                        <p className="text-sm font-semibold text-gray-900" data-id="element-322">
                          {esigenza.esigenza}
                        </p>
                      </td>
                      <td className="px-4 py-4" data-id="element-323">
                        <p className="text-sm text-gray-600" data-id="element-324">
                          {esigenza.dettagli}
                        </p>
                      </td>
                      <td className="px-4 py-4 whitespace-nowrap" data-id="element-325">
                        <p className="text-sm text-gray-900" data-id="element-326">
                          {esigenza.budget}
                        </p>
                      </td>
                      <td className="px-4 py-4 whitespace-nowrap" data-id="element-327">
                        <p className="text-sm text-gray-600" data-id="element-328">
                          {esigenza.dataRichiesta}
                        </p>
                      </td>
                      <td className="px-4 py-4" data-id="element-329">
                        {esigenza.soluzioneProposta === '-' ? <p className="text-sm text-gray-400 italic" data-id="element-330">
                            {esigenza.soluzioneProposta}
                          </p> : <button onClick={() => {
                    const immobile = mockImmobili.find(i => i.nome === esigenza.soluzioneProposta);
                    if (immobile) setSelectedImmobile(immobile);
                  }} className="flex items-center gap-2 hover:opacity-80 transition-opacity" data-id="element-331">
                            <img src={mockImmobili.find(i => i.nome === esigenza.soluzioneProposta)?.immagine} alt={esigenza.soluzioneProposta} className="w-10 h-10 object-cover rounded-lg flex-shrink-0" data-id="element-332" />
                            <span className="text-sm text-[#1388ad] font-normal hover:underline" data-id="element-333">
                              {esigenza.soluzioneProposta}
                            </span>
                          </button>}
                      </td>
                      <td className="px-4 py-4" data-id="element-334">
                        <span className={`px-3 py-1 text-xs font-normal rounded-full whitespace-nowrap ${stageColors[esigenza.statoTrattativa]}`} data-id="element-335">
                          {esigenza.statoTrattativa}
                        </span>
                      </td>
                    </tr>)}
                </tbody>
              </table>
            </div>}
          {activeTab === 'referenti' && <div className="space-y-4" data-id="element-336">
              {mockReferenti.map(referente => <div key={referente.id} className="p-4 border border-gray-200 rounded-lg hover:border-[#1388ad] transition-colors" data-id="element-337">
                  <div className="flex items-start justify-between" data-id="element-338">
                    <div className="flex items-start gap-3" data-id="element-339">
                      <div className="w-10 h-10 bg-[#1388ad]/10 rounded-full flex items-center justify-center" data-id="element-340">
                        <User className="w-5 h-5 text-[#1388ad]" data-id="element-341" />
                      </div>
                      <div data-id="element-342">
                        <div className="flex items-center gap-2" data-id="element-343">
                          <p className="text-sm font-semibold text-gray-900" data-id="element-344">
                            {referente.name}
                          </p>
                          {referente.isPrimary && <span className="px-2 py-0.5 bg-[#1388ad] text-white text-xs rounded-full" data-id="element-345">
                              Primario
                            </span>}
                        </div>
                        <p className="text-sm text-gray-500 mt-1" data-id="element-346">
                          {referente.role}
                        </p>
                        <div className="flex flex-col gap-1 mt-3" data-id="element-347">
                          <div className="flex items-center gap-2 text-sm text-gray-600" data-id="element-348">
                            <Mail className="w-3 h-3" data-id="element-349" />
                            <a href={`mailto:${referente.email}`} className="hover:text-[#1388ad]" data-id="element-350">
                              {referente.email}
                            </a>
                          </div>
                          <div className="flex items-center gap-2 text-sm text-gray-600" data-id="element-351">
                            <Phone className="w-3 h-3" data-id="element-352" />
                            <a href={`tel:${referente.phone}`} className="hover:text-[#1388ad]" data-id="element-353">
                              {referente.phone}
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>)}
            </div>}
          {activeTab === 'trattative' && <div className="space-y-4" data-id="element-354">
              {mockTrattative.map(trattativa => <div key={trattativa.id} className="p-4 border border-gray-200 rounded-lg hover:border-[#1388ad] transition-colors cursor-pointer" onClick={() => navigate(`/deals`)} data-id="element-355">
                  <div className="flex items-start justify-between" data-id="element-356">
                    <div data-id="element-357">
                      <p className="text-sm font-semibold text-gray-900" data-id="element-358">
                        {trattativa.property}
                      </p>
                      <div className="flex items-center gap-3 mt-2" data-id="element-359">
                        <span className={`px-2 py-1 text-xs rounded-full ${stageColors[trattativa.stage]}`} data-id="element-360">
                          {trattativa.stage}
                        </span>
                        <span className="text-sm font-semibold text-[#1388ad]" data-id="element-361">
                          €{trattativa.value.toLocaleString()}
                        </span>
                      </div>
                      <div className="flex items-center gap-4 mt-2 text-xs text-gray-500" data-id="element-362">
                        <span data-id="element-363">Inizio: {trattativa.startDate}</span>
                        <span data-id="element-364">
                          Ultimo aggiornamento: {trattativa.lastUpdate}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>)}
            </div>}
          {activeTab === 'comunicazioni' && <div className="space-y-3" data-id="element-365">
              {mockComunicazioni.map(comunicazione => <div key={comunicazione.id} className="p-4 border border-gray-200 rounded-lg hover:bg-gray-50 transition-colors" data-id="element-366">
                  <div className="flex items-start gap-3" data-id="element-367">
                    <div className={`p-2 rounded-lg ${comunicazione.type === 'email' ? 'bg-blue-100' : comunicazione.type === 'call' ? 'bg-green-100' : 'bg-purple-100'}`} data-id="element-368">
                      {comunicazione.type === 'email' ? <Mail className="w-4 h-4 text-blue-600" data-id="element-369" /> : comunicazione.type === 'call' ? <Phone className="w-4 h-4 text-green-600" data-id="element-370" /> : <Calendar className="w-4 h-4 text-purple-600" data-id="element-371" />}
                    </div>
                    <div className="flex-1" data-id="element-372">
                      <p className="text-sm font-semibold text-gray-900" data-id="element-373">
                        {comunicazione.subject}
                      </p>
                      <div className="flex items-center gap-2 mt-1 text-xs text-gray-500" data-id="element-374">
                        <span data-id="element-375">Da: {comunicazione.from}</span>
                        <span data-id="element-376">•</span>
                        <span data-id="element-377">A: {comunicazione.to}</span>
                      </div>
                      <p className="text-xs text-gray-500 mt-1" data-id="element-378">
                        {comunicazione.date}
                      </p>
                    </div>
                  </div>
                </div>)}
            </div>}
        </div>
      </div>
      {selectedImmobile && <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4" data-id="element-379">
          <div className="bg-white w-full max-w-4xl max-h-[90vh] overflow-y-auto rounded-lg" data-id="element-380">
            <div className="sticky top-0 bg-white border-b border-gray-200 p-6 flex items-center justify-between rounded-t-lg" data-id="element-381">
              <div data-id="element-382">
                <h2 className="text-xl font-semibold text-gray-900" data-id="element-383">
                  {selectedImmobile.nome}
                </h2>
                <p className="text-sm text-gray-500 mt-1" data-id="element-384">
                  {selectedImmobile.tipo} • {selectedImmobile.superficie}
                </p>
              </div>
              <button onClick={() => setSelectedImmobile(null)} className="p-2 hover:bg-gray-100 transition-colors rounded-full" data-id="element-385">
                <X className="w-5 h-5 text-gray-500" data-id="element-386" />
              </button>
            </div>
            <div className="p-6 space-y-6" data-id="element-387">
              <img src={selectedImmobile.immagine} alt={selectedImmobile.nome} className="w-full h-64 object-cover rounded-lg" data-id="element-388" />
              <div className="grid grid-cols-3 gap-4" data-id="element-389">
                <div className="p-4 bg-gray-50 rounded-lg" data-id="element-390">
                  <p className="text-xs text-gray-500 mb-1" data-id="element-391">Prezzo</p>
                  <p className="text-lg font-semibold text-[#1388ad]" data-id="element-392">
                    €{selectedImmobile.prezzo.toLocaleString()}
                  </p>
                </div>
                <div className="p-4 bg-gray-50 rounded-lg" data-id="element-393">
                  <p className="text-xs text-gray-500 mb-1" data-id="element-394">Tipo</p>
                  <p className="text-lg font-semibold text-gray-900" data-id="element-395">
                    {selectedImmobile.tipo}
                  </p>
                </div>
                <div className="p-4 bg-gray-50 rounded-lg" data-id="element-396">
                  <p className="text-xs text-gray-500 mb-1" data-id="element-397">Superficie</p>
                  <p className="text-lg font-semibold text-gray-900" data-id="element-398">
                    {selectedImmobile.superficie}
                  </p>
                </div>
              </div>
              <div data-id="element-399">
                <h3 className="text-sm font-semibold text-gray-900 mb-2" data-id="element-400">
                  Descrizione
                </h3>
                <p className="text-sm text-gray-600" data-id="element-401">
                  {selectedImmobile.descrizione}
                </p>
              </div>
              <div data-id="element-402">
                <h3 className="text-sm font-semibold text-gray-900 mb-3" data-id="element-403">
                  Caratteristiche
                </h3>
                <div className="grid grid-cols-2 gap-3" data-id="element-404">
                  {selectedImmobile.caratteristiche.map((car, idx) => <div key={idx} className="flex items-center gap-2 text-sm text-gray-600" data-id="element-405">
                      <span className="w-2 h-2 bg-[#1388ad] rounded-full" data-id="element-406"></span>
                      <span data-id="element-407">{car}</span>
                    </div>)}
                </div>
              </div>
              <div className="flex gap-3 pt-4 border-t border-gray-200" data-id="element-408">
                <button onClick={() => setSelectedImmobile(null)} className="flex-1 px-6 py-3 border-2 border-gray-300 text-gray-700 text-sm font-normal hover:bg-gray-50 transition-colors rounded-full" data-id="element-409">
                  Chiudi
                </button>
                <button onClick={() => {
              setSelectedImmobile(null);
              navigate(`/properties/${selectedImmobile.id}`);
            }} className="flex-1 px-6 py-3 bg-[#1388ad] text-white text-sm font-normal hover:bg-[#0f6b8a] transition-colors rounded-full" data-id="element-410">
                  Vedi Dettagli Completi
                </button>
              </div>
            </div>
          </div>
        </div>}
    </div>;
}